import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Container,
  Spinner,
} from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import Select from "react-select";
import { toast } from "react-toastify";
import { getRecords, saveRecords } from "../../../services/api.service";
import Asterisks from "../../../custom/components/Asterisks/Asterisks";
import SelectInput from "../../../custom/components/Select-Input/SelectInput";
import CheckboxInput from "../../../custom/components/CheckBox-Input/CheckboxInput";

const UserMenuAccess = () => {
  const userType = [
    { label: "Bermad User", value: 1 },
    { label: "Subcontractor", value: 2 },
    { label: "Customer", value: 3 },
  ];
  const [selectedUserRole, setSelectedUserRole] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userOptions, setUserOptions] = useState([]);
  const [roleSelectOptions, setRoleSelectOptions] = useState([]);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [UserRoleError, setUserRoleError] = useState(false);
  const [UserError, setUserError] = useState(false);

  const getUserData = async (selectedUserRole) => {
    const schema = localStorage.getItem("schema");

    if (!selectedUserRole) {
      setUserRoleError(!selectedUserRole ? true : false);
      return;
    }
    const payload = {
      schema: schema,
      modelName: "user_masters",
      whereCondition: { is_active: true, role_id: selectedUserRole?.value },
    };
    const responseData = await getRecords(payload, "/getRecords");
    if (responseData) {
      const userOptionsData = responseData.data.map((opt) => ({
        label: opt.first_name + " " + opt.last_name,
        value: opt.id,
      }));
      setUserOptions(userOptionsData);
    }
  };

  useEffect(() => {
    getRoleData();
  }, []);
  const getRoleData = async () => {
    const schema = localStorage.getItem("schema");
    try {
      let payload = {
        modelName: "role_masters",
        whereCondition: {
          is_active: true,
        },
        schema: schema,
        orderBy: {
          field: "role_name",
          order: "asc",
        },
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map((item) => ({
        value: item.id,
        label: item.role_name,
      }));
      setRoleSelectOptions(newArray);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleUserRoleSelectChange = (options) => {
    const selectedValue = options ? options.value : "";

    setSelectedUserRole(options);
    setSelectedUser(null);
    getUserData(options);
    setUserRoleError(false);
    setData([]);
  };

  const handleUserSelectChange = (user) => {
    setSelectedUser(user);
    setUserError(false);
    setData([]);
  };

  const handleGo = async () => {
    if (!selectedUserRole || !selectedUser) {
      setUserRoleError(!selectedUserRole ? true : false);
      setUserError(!selectedUser ? true : false);
      return;
    }

    const payload = {
      modelName: "menu_masters",
      whereCondition: {
        is_active: true,
      },
      pagination: { page: 1, pageSize: 1000000 },
      relations: [
        {
          module: "user_access",
          moduleAs: "user_access",
        },
        {
          module: "user_type_menu_access",
          moduleAs: "user_type_menu_access",
          isModuleWhereConditionRequired: true,
          required: true,
        },
      ],
      moduleWhereCondition: {
        user_type: selectedUserRole?.value,
        is_active: true,
        access: true,
      },
    };

    setLoading(true);
    const responseData = await getRecords(payload, "/getRecords");
    setLoading(false);

    if (responseData?.data?.length > 0) {
      const updatedData = responseData?.data?.map((item) => {
        // Check if the user has access in the user_type_menu_access array
        let userTypeAccess = false;
        let primary_id = undefined;

        if (item?.user_access && item?.user_access.length > 0) {
          item?.user_access.forEach((element) => {
            if (
              selectedUser?.value &&
              element?.user_id == selectedUser?.value
            ) {
              primary_id = element.id;
              userTypeAccess = element.access ? true : false;
            }
          });
        }

        return {
          ...item,
          isChecked: userTypeAccess ? true : false, // Set isChecked based on access
          primary_id: primary_id || undefined,
        };
      });
      setData(updatedData);
    } else {
      setData([]);
      toast.info("No menu found for the selected user role.");
    }
  };

  const handleToggleExpand = (id) => {
    setData((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, isExpanded: !item.isExpanded } : item
      )
    );
  };

  const handleCheckboxChange = (id, checked) => {
    setData((prev) =>
      prev.map((item) =>
        item.id === id || item.parent_id === id
          ? { ...item, isChecked: checked }
          : item
      )
    );

    if (checked) {
      const childParentMenuId = data
        .filter((child) => child.id === id)
        .map((child) => child.parent_id)[0];
      if (childParentMenuId) {
        setData((prev) =>
          prev.map((item) =>
            item.id === childParentMenuId
              ? { ...item, isChecked: checked }
              : item
          )
        );
      }
    }
  };
  const handleSubmit = async () => {
    if (!selectedUserRole || !selectedUser) {
      toast.error("Please select a user role & user.");
      return;
    }
    const checkedUsers = data
      .filter((user) => user.isChecked)
      .map((user) => user.id); // Extract their IDs
    // Ensure at least one user is selected
    if (checkedUsers.length === 0) {
      toast.error("Please select at least one user.");
      return;
    }
    setLoading(true);

    const payload = {
      modelName: "user_access",
      inputData: data.map((item) => ({
        id: item.primary_id, // Use primary_id (the ID from user_type_menu_access)
        user_type: selectedUserRole?.value, // Use selected user type value
        user_id: selectedUser?.value, // Use selected user
        menu_id: item.id,
        access: item.isChecked ?? false,
        is_active: true,
      })),
    };
    // API call to save the records
    try {
      const response = await saveRecords(payload, "/saveRecords");

      if (response.code === 1) {
        setData([]);
        setSelectedUserRole(null);
        setSelectedUser(null);
        setUserOptions([]);
        toast.success("Access successfully updated.");
        setTimeout(() => {
          window.location.reload();
        }, 500);
      } else {
        toast.error("Failed to update access.");
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An error occurred while submitting data.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="MENU ACCESS" breadcrumbItems={[]} />
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Row className="justify-content-center ">
                      <Col md={4}>
                        <SelectInput
                          label="User Role"
                          value={selectedUserRole}
                          onSelect={handleUserRoleSelectChange}
                          options={roleSelectOptions}
                          classNamePrefix="select2-selection"
                          noOptionsMessage={() => "No data found."}
                          maxMenuHeight={200}
                          asterisk={true}
                          isClearable={true}
                          customError={
                            (UserRoleError && "Please select a user role.") ||
                            ""
                          }
                        />
                      </Col>

                      <Col md={4}>
                        <SelectInput
                          label="User"
                          value={selectedUser}
                          onSelect={handleUserSelectChange}
                          options={userOptions}
                          classNamePrefix="select2-selection"
                          noOptionsMessage={() => "No data found."}
                          maxMenuHeight={200}
                          asterisk={true}
                          isClearable={true}
                          customError={
                            (UserError && "Please select a user.") || ""
                          }
                        />
                      </Col>

                      <Col style={{ marginTop: "28px", paddingBottom: "20px" }}>
                        <Button
                          onClick={handleGo}
                          color="primary"
                          type="button"
                          className="waves-effect waves-light me-1"
                          style={{ background: "#006eb9" }}
                        >
                          Go
                        </Button>
                      </Col>
                    </Row>
                    <Row
                      className="justify-content-center table mt-2"
                      style={{
                        overflowX: "auto",
                        overflowY: "auto",
                        maxHeight: "55vh",
                        width: "100%",
                        scrollBehavior: "smooth",
                        scrollbarWidth: "thin",
                        msOverflowStyle: "none",
                        zIndex: 0,
                      }}
                    >
                      {loading ? (
                        <div style={{ textAlign: "center", marginTop: "20px" }}>
                          <Spinner color="primary" />
                        </div>
                      ) : (
                        <Row style={{ width: "100%" }}>
                          <Col xl="12">
                            <table className="table table-bordered">
                              <thead
                                style={{
                                  backgroundColor: "#f9992d",
                                  position: "sticky",
                                  top: 0,
                                  backgroundColor: "#f9992d",
                                  zIndex: 1,
                                }}
                              >
                                <tr>
                                  <th>Menu Name</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {data.length > 0 ? (
                                  data
                                    .filter((item) => item.parent_id === null) // Render only parent menus initially
                                    .map((parent) => (
                                      <React.Fragment key={parent.id}>
                                        <tr>
                                          <td
                                            style={{
                                              cursor: "pointer",
                                              fontWeight: "bold",
                                            }}
                                            onClick={() =>
                                              handleToggleExpand(parent.id)
                                            }
                                          >
                                            {parent.isExpanded ? "▼" : "▶"}{" "}
                                            {parent.menu_name}
                                          </td>
                                          <td>
                                            <CheckboxInput
                                              value={parent?.isChecked}
                                              checked={parent?.isChecked}
                                              handleTextChange={(e) =>
                                                handleCheckboxChange(
                                                  parent?.id,
                                                  e.target.checked
                                                )
                                              }
                                              parentClassName="form-check"
                                              checkBoxClassName="form-check-input"
                                              labelClassName="form-check-label"
                                              labelStyle={{
                                                display: "none",
                                              }}
                                              checkboxStyle={{
                                                width: "16px",
                                                height: "16px",
                                              }}
                                            />
                                          </td>
                                        </tr>
                                        {parent.isExpanded &&
                                          data
                                            .filter(
                                              (child) =>
                                                child.parent_id === parent.id
                                            )
                                            .map((child) => (
                                              <tr
                                                key={child.id}
                                                style={{
                                                  paddingLeft: "20px",
                                                }}
                                              >
                                                <td>
                                                  &emsp;↳ {child.menu_name}
                                                </td>
                                                <td>
                                                  <CheckboxInput
                                                    value={child?.isChecked}
                                                    checked={child?.isChecked}
                                                    handleTextChange={(e) =>
                                                      handleCheckboxChange(
                                                        child?.id,
                                                        e.target.checked
                                                      )
                                                    }
                                                    parentClassName="form-check"
                                                    checkBoxClassName="form-check-input"
                                                    labelClassName="form-check-label"
                                                    labelStyle={{
                                                      display: "none",
                                                    }}
                                                    checkboxStyle={{
                                                      width: "16px",
                                                      height: "16px",
                                                    }}
                                                  />
                                                </td>
                                              </tr>
                                            ))}
                                      </React.Fragment>
                                    ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="2"
                                      style={{ textAlign: "center" }}
                                    >
                                      No menus found.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </Col>
                        </Row>
                      )}
                    </Row>

                    {data.length > 0 && (
                      <Row className="mt-4 justify-content-center">
                        <Col
                          style={{
                            paddingTop: "10px",
                            borderTop: "1px solid #ced4da",
                            display: "flex",
                            justifyContent: "center",
                            textAlign: "center",
                          }}
                        >
                          <Button color="primary" onClick={handleSubmit}>
                            Submit
                          </Button>
                        </Col>
                      </Row>
                    )}
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UserMenuAccess;
